import { Link } from 'react-router-dom';

const COLUMNS = [
  {
    title: 'שירותים',
    links: [
      { label: 'תיקון מחשבים', to: '/services' },
      { label: 'החלפת מסך למחשב נייד', to: '/laptop-screen-replacement' },
      { label: 'מחשב איטי', to: '/slow-computer' },
      { label: 'טכנאי מחשבים בצפון', to: '/computer-technician-north' },
      { label: 'בניית מחשב גיימינג', to: '/build-pc' },
      { label: 'מעקב תיקון', to: '/repair-status' },
      { label: 'חבילות תחזוקה', to: '/plans' },
    ],
  },
  {
    title: 'ידע',
    links: [
      { label: 'קונים מחשב נייד', to: '/guides/laptop-buying' },
      { label: 'תקלות ותיקונים', to: '/guides/computer-problems' },
      { label: 'שדרוגים וגיימינג', to: '/guides/upgrades-and-gaming' },
      { label: 'כל המדריכים', to: '/blog' },
      { label: 'קונים דרך המעבדה', to: '/shop' },
      { label: 'ייעוץ חינם', to: '/diagnose' },
      { label: 'קביעת תור', to: '/booking' },
    ],
  },
  {
    title: 'חברה',
    links: [
      { label: 'אודות', to: '/about' },
      { label: 'בלוג', to: '/blog' },
      { label: 'המעבדה', to: '/lab' },
      { label: 'פורטפוליו', to: '/portfolio' },
      { label: 'צרו קשר', to: '/contact' },
    ],
  },
  {
    title: 'משפטי',
    links: [
      { label: 'נגישות', to: '/accessibility' },
      { label: 'פרטיות', to: '/privacy' },
      { label: 'תנאי שימוש', to: '/terms' },
      { label: 'שאלות נפוצות', to: '/faq' },
    ],
  },
];

export default function CinFooter() {
  return (
    <footer className="font-heebo bg-white border-t border-[var(--cin-line)]">
      <div className="mx-auto max-w-[1280px] px-5 md:px-8 lg:px-20 py-16 md:py-20">
        {/* Top — brand + columns */}
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8 md:gap-12 mb-14">
          {/* Brand */}
          <div className="col-span-2">
            <Link to="/" aria-label="בנה מחשבים — דף הבית" className="inline-flex items-center gap-1.5 text-2xl font-black tracking-tight text-[var(--cin-ink)] mb-4">
              <span className="cin-text-gradient-blue">בנה</span>
              <span>מחשבים</span>
            </Link>
            <p className="text-sm text-[var(--cin-muted)] leading-relaxed max-w-xs">
              מעבדת מחשבים בנטור, רמת הגולן. תיקון, הרכבה ותחזוקה ללקוחות פרטיים, מצפת ועד דרום.
            </p>
            <a
              href="https://wa.me/972546672863"
              data-track-from="footer"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-sm font-semibold text-[var(--cin-ink)] hover:text-[var(--cin-blue)] transition-colors"
            >
              <span>וואטסאפ · 054-667-2863</span>
              <span>←</span>
            </a>

            {/* B2B sister hub — redirects to the new local-business page */}
            <Link
              to="/business/local"
              className="mt-6 block bg-[var(--cin-paper-soft)] border border-[var(--cin-line)] hover:border-[var(--cin-blue)]/40 rounded-xl p-4 transition-colors group"
            >
              <div className="text-xs font-semibold uppercase tracking-wider text-[var(--cin-muted)] mb-1">
                בעל עסק בצפון?
              </div>
              <div className="text-sm font-bold text-[var(--cin-ink)] mb-1">
בנה מחשבים לעסקים: מגיעים עד אליכם
              </div>
              <div className="text-xs text-[var(--cin-muted)] group-hover:text-[var(--cin-blue)] transition-colors">
                CRM, IT, תחזוקה · שיחת ייעוץ חינם →
              </div>
            </Link>
          </div>

          {/* Columns */}
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <div className="cin-label-ed mb-4 text-[11px]">{col.title}</div>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Free interactive tools — static lead-magnet pages OUTSIDE the SPA,
            so they must use <a href> (a <Link> would client-route into a 404). */}
        <div className="pt-8 border-t border-[var(--cin-line)] mb-6">
          <div className="cin-label-ed mb-3 text-[11px]">כלים חינמיים</div>
          <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
            <a href="/laptop-quiz/" className="text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors">בוחר המחשב הנייד</a>
            <a href="/repair-or-replace/" className="text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors">לתקן או לקנות חדש?</a>
            <a href="/buying-checklist/" className="text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors">צ'ק-ליסט קנייה</a>
            <a href="/laptop-guide-2026/" className="text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors">המדריך לקניית מחשב</a>
            <a href="/tools/keyboard-test/" className="text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors">בדיקת מקלדת</a>
            <a href="/tools/screen-test/" className="text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors">בדיקת מסך</a>
            <a href="/tools/camera-mic-test/" className="text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors">בדיקת מצלמה ומיקרופון</a>
            <a href="/tools/battery-health/" className="text-[var(--cin-muted)] hover:text-[var(--cin-ink)] transition-colors">בדיקת סוללה</a>
            <a href="/tools/" className="font-semibold text-[var(--cin-blue)] hover:underline">כל הכלים ←</a>
          </div>
        </div>

        {/* Google review CTA — visible on every page */}
        <div className="pt-8 border-t border-[var(--cin-line)] mb-6">
          <a
            href="https://g.page/r/CaXKbaQyBBmLEAE/review"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 text-sm font-semibold text-[var(--cin-ink)] hover:text-[var(--cin-blue)] transition-colors group"
          >
            <span className="text-amber-500 text-base" aria-hidden="true">★★★★★</span>
            <span>נהניתם מהשירות? תנו לנו ביקורת בגוגל</span>
            <span className="text-[var(--cin-muted)] group-hover:text-[var(--cin-blue)] transition-colors">↗</span>
          </a>
        </div>

        {/* Bottom — copyright + full business disclosure (Consumer Protection Law §17) */}
        <div className="pt-6 border-t border-[var(--cin-line)] flex flex-col gap-3 text-xs text-[var(--cin-muted)]">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-3">
            <div>
              © {new Date().getFullYear()} בנה מחשבים · המקצוענים שלכם מהצפון · מ-2018
            </div>
            <div className="flex flex-wrap gap-x-5 gap-y-1">
              <span dir="ltr">benapc.com</span>
              <span>·</span>
              <span>מושב נטור, רמת הגולן</span>
              <span>·</span>
              {/* No fixed hours — the lab works by appointment (owner, 2026-10-10). */}
              <span>שירות בתיאום מראש</span>
            </div>
          </div>
          <div className="flex flex-wrap gap-x-5 gap-y-1 text-[11px]">
            <span>בעלים: בניהו</span>
            <span>·</span>
            <span dir="ltr">ע.מ 201536679</span>
            <span>·</span>
            <a href="mailto:info@benapc.com" className="hover:text-[var(--cin-ink)] transition-colors" dir="ltr">info@benapc.com</a>
            <span>·</span>
            <a href="tel:+972546672863" className="hover:text-[var(--cin-ink)] transition-colors" dir="ltr">054-667-2863</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
